import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { FaSpinner  } from 'react-icons/fa';
import { MdOutlineUploadFile, MdOutlineCloudDownload } from "react-icons/md";
import usePageTitle from 'hooks/usePageTitle';
import useIsMobile from 'utils/isMobileUtils';



const ImportProduct = () => {
	
	const [setPageTitle] = usePageTitle('Products - Import');
	useEffect(() => {
		return () => {
			setPageTitle(null);
		};
	}, []);
	const history = useNavigate();
	const [file, setFile] = useState(null);
	const [selectedStrategy, setSelectedStrategy] = useState(0);
	const [isImportRunning, setIsImportRunning] = useState(false);
	const strategyTypes = [
		{ label: 'Add new products and update existing products', value: 0 },
		{ label: 'Only add new products, ignore existing products', value: 1 },
		{ label: 'Only update existing products, ignore new products', value: 2 },
	];

	const exportSheet = () => {
		const data = {
			startDate: '2021-01-01',
			endDate: '2021-12-31'
		};
		api.importProductsFormat(data).then((res) => {
				var newBlob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				saveAs(newBlob, `Projectmix - Import Products Format.xlsx`);
			
		});
	};


	const importSheet = () => {
		setIsImportRunning(true)
		api.importProducts(
			file,
			selectedStrategy
		).then((res) => {
			if(res.success === true){
				toast.success('Products imported successfully');

			}else{
				if(res.status != 200){
					toast.error(res?.data?.message);
				}
			}
			setIsImportRunning(false)
		});
	//    setFile(null)
	}

	const handleFileInput = (e) => {
		const file = event.target.files[0];
		if (file && file.name) {
			const fileExtension = file.name.split('.').pop();
	
			if (fileExtension !== 'xlsx') {
				toast.error('Invalid file format. Please upload a .xlsx file.');
				setFile(null)
				return;
			} else {
				setFile(e.target.files[0])
			}
		}
	}

	const isMobile = useIsMobile();
	return (
		<>
			<div className="row">
				<div className="col-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								{' '}
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									{/* Replace with your fi arrow icon, example below */}
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
									Import
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 10 }}>
								<button className="btn btn-outlined-main" style={{ marginRight: '4px' }} onClick={() => exportSheet()}>
									<MdOutlineCloudDownload /> Export format
								</button>
								<button className="btn btn-outlined-main" style={{ marginLeft: '4px' }} onClick={() => importSheet()}>
									<MdOutlineUploadFile /> Import
								</button>
							</div>
						</div>
					</div>
					<div className="row pb10">
						<div className="col-12">
							<div className="section-head-new"></div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<div className={`${isMobile ? '' : 'card p-2'}`}>
						<div className="content pad15">
							<div className="row m-0 p-0 mb-3 hide-on-mobile">
								<div className="col-md-2 col-sm-3 col-12">
									<h4 className="font18">
										<b>Import</b>
									</h4>
								</div>
							</div>
							{!isMobile ? (
								<div className="row">
									<div className="col-md-4 col-3 text-right form-group">File</div>
									<div className="col-md-4 col-9 form-group">
										<div className="prdct-inactiv-div-yes">
											<div className="yes">
												<input
													type="file"
													name="act-product"
													className="form-control"
													onChange={(e) => handleFileInput(e)}
													accept=".xlsx"
												/>
											</div>
											<div className="">
												{' '}
												<span>Choose an Excel (.xlsx) file to import.</span>
											</div>
										</div>
									</div>
								</div>
							) : (
								<div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '0px 20px' }}>
									<div style={{ fontWeight: 500, fontSize: 16 }}>File</div>
									<label
										htmlFor="import-dropzone"
										style={{
											border: '2px dashed #1976d2',
											borderRadius: 10,
											padding: '32px 0',
											background: '#f8fafd',
											color: '#1976d2',
											textAlign: 'center',
											cursor: 'pointer',
											fontWeight: 500,
											fontSize: 15,
											transition: 'border 0.2s',
											marginBottom: 8,
											display: 'flex',
											flexDirection: 'column',
											alignItems: 'center',
											gap: 8
										}}
									>
										<MdOutlineUploadFile size={32} />
										{file ? (
											<span style={{ color: '#222', fontWeight: 600 }}>{file.name}</span>
										) : (
											<>
												<span>Tap or drag to select your Excel (.xlsx) file</span>
												<span style={{ fontSize: 13, color: '#888' }}>Only .xlsx files are supported</span>
											</>
										)}
										<input
											id="import-dropzone"
											type="file"
											name="act-product"
											style={{ display: 'none' }}
											onChange={handleFileInput}
											accept=".xlsx"
										/>
									</label>
								</div>
							)}
							{!isMobile ? (
								<div className="row">
									<div className="col-md-4 col-3 text-right form-group">Strategy</div>
									<div className="col-md-4 col-9 form-group">
										<div className="row" style={{ marginTop: '5px' }}>
											<div className="col-12">
												{strategyTypes?.map((strategy, index) => (
													<div key={index}>
														<input
															type="radio"
															name="act-product-yes"
															onClick={() => {
																setSelectedStrategy(strategy?.value);
															}}
															checked={strategy?.value === selectedStrategy ? true : false}
														/>{' '}
														<span htmlFor="">{strategy.label}</span>
													</div>
												))}
											</div>
										</div>
									</div>
								</div>
							) : (
								<div style={{ display: 'flex', flexDirection: 'column', gap: 10, padding: '0px 20px' }}>
									<div style={{ fontWeight: 500, fontSize: 16 }}>Strategy</div>
									<div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
										{strategyTypes?.map((strategy, index) => (
											<div
												key={index}
												style={{
													display: 'flex',
													alignItems: 'center',
													padding: '10px 15px',
													borderRadius: 5,
													border: '1px solid #ccc',
													backgroundColor: selectedStrategy === strategy.value ? '#e3f2fd' : '#fff',
													transition: 'background-color 0.2s',
													cursor: 'pointer'
												}}
												onClick={() => {
													setSelectedStrategy(strategy?.value);
												}}
											>
												<input type="radio" name="act-product-yes" checked={strategy?.value === selectedStrategy ? true : false} />
												<span style={{ marginLeft: 8 }}>{strategy.label}</span>
											</div>
										))}
									</div>
								</div>
							)}
							<div className="row m-0 p-0 mb-3 hide-on-mobile">
								<div className="col-12">
									<div style={{ display: 'flex', justifyContent: 'center' }}>
										<button className="btn btn-outlined-main" style={{ marginRight: '4px' }} onClick={() => exportSheet()}>
											<MdOutlineCloudDownload /> Export format
										</button>
										{isImportRunning ? (
											<button className="btn btn-outlined-main disabled" disabled>
												<FaSpinner style={{ animation: 'spin 2s linear infinite' }} /> Importing...
											</button>
										) : (
											<button className="btn btn-outlined-main" style={{ marginLeft: '4px' }} onClick={() => importSheet()}>
												<MdOutlineUploadFile /> Import
											</button>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ImportProduct;
